import styled from "styled-components";

export const ModalContent = styled.div`
  margin: 0px;
  font-size: 1rem;
  color: rgb(0, 0, 0);
  font-family: "Roboto Flex", Roboto, sans-serif;
  font-weight: 400;
  line-height: 125%;
  padding: 0px 24px;
  font-variation-settings: "opsz" 16;
  > * {
    margin-bottom: 16px;
  }
`;

export const ModalFooter = styled.div`
  padding-right: 24px;
  padding-bottom: 24px;
`;
